import React, {useEffect, useState} from 'react';
import { useQueryClient } from 'react-query';
import __ from "lodash";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import { FixedSizeList } from 'react-window';
import { ListItem } from "@material-ui/core";
import {useContracts} from "../../../services/contracts";



/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  root: {
    width: '50%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

const ContractSelect = (props) => {
  const width = props.width || 200;
  const height = props.height || 550;
  const classes = props.classes;
  const SystemData = props.systemData;
  const eventBus = SystemData.eventBus;

  const [extraKeys, setExtraKeys] = useState(["null", "null", "null"]);
  const queryClient = useQueryClient();
  const contractRecords = useContracts({queryClient, useCache: false, extraKeys});

  let records = [];
  if (contractRecords && contractRecords.data) {
    contractRecords.data.forEach(record => {
      records.push(record);
    });
  }

  useEffect(()=> {
    const search = async (params) => {
      const { contractName, contractType, contractedPartyUuid} = params;
      const extraKeys = [];
      extraKeys.push(!contractName || contractName === "" ? "null" : contractName);
      extraKeys.push(!contractType || contractType === "" ? "null" : contractType);
      extraKeys.push(!contractedPartyUuid || contractedPartyUuid === "" ? "null" : contractedPartyUuid);

      setExtraKeys(extraKeys);
    }
    eventBus.bind("ContractSelect.search", search);
    return () => {
      eventBus.unbind("ContractSelect.search", search);
    }
  }, [extraKeys, eventBus, queryClient]);

  const handleSelect = (contractUuid) => () => {
    if (props.onSelect)
      props.onSelect(contractUuid);
  }

  const renderEmpty = (props) => {
    const {index, style, isScrolling} = props;
    const emptyList = [{contractName: "No Contracts Found for the requested search criteria"}]

    const record = emptyList[index];
    const key = `${record.contractName}`;

    return (
      <ListItem key={key} style={style} dense disablePadding button>
        <div style={{fontSize: "13px"}}>
          {`${record.contractName}`}
        </div>
      </ListItem>
    );
  }
  const renderRow = (props) => {
    const {index, style, isScrolling} = props;

    const record = records[index];
    const key = `${record.contractUuid}`;

    return (
      <ListItem key={key} style={style} dense disablePadding button onClick={handleSelect(key)}>
        <div style={{fontSize: "13px"}}>
          {`${record.contractName} (${record.contractTypeName}) - ${record.company?.companyName}`}
        </div>
      </ListItem>
    );
  }

  renderRow.propTypes = {
    index: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
  };

  return (
    records && records.length > 0
      ?
        <FixedSizeList
          height={height}
          width={width}
          itemSize={38}
          itemCount={records.length}
          useIsScrolling
        >
          {renderRow}
        </FixedSizeList>
      :
      <FixedSizeList
        height={height}
        width={width}
        itemSize={38}
        itemCount={1}
        useIsScrolling
      >
        {renderEmpty}
      </FixedSizeList>
  );
}

export default withStyles(styles) (ContractSelect);
